export default __webpack_public_path__ + "static/media/city_builder_image.5d1739c1.png";